import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tabs, Tab } from '@mui/material';
import SystemCommunicationTab from './SystemCommunicationTab';
import AnnouncementsPage from '../AnnouncementsPage';

export default function SystemCommunicationsPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);
  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label={t('systemCommunications.messages', 'Messages')} />
        <Tab label={t('systemCommunications.announcements', 'Announcements')} />
      </Tabs>
      {tab === 0 && <SystemCommunicationTab />}
      {tab === 1 && <AnnouncementsPage />}
    </Box>
  );
}
